// initial state
const state = {
  all: [],
}

// getters
const getters = {
}

// actions
const actions = {
  allCountries({ dispatch }) {
    return dispatch(
      'http',
      {
        method: 'GET',
        url: '/countries',
      },
      { root: true },
    )
  },
  allLanguages({ dispatch }) {
    return dispatch(
      'http',
      {
        method: 'GET',
        url: '/languages',
      },
      { root: true },
    )
  },
}

// mutations
const mutations = {
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
